import { computed } from "mobx";
import { FieldType, ViewModelBase } from "@shoothill/core";
import moment from "moment";
import { RDDV2ItemResponseModel } from "./RDDV2ItemResponseModel";

export class RDDV2ItemResponseViewModel extends ViewModelBase<RDDV2ItemResponseModel> {
    constructor(item: RDDV2ItemResponseModel) {
        super(item);
    }

    @computed
    public get id() {
        return this.model.id;
    }

    @computed
    public get rddV2Id() {
        return this.model.rddV2Id;
    }

    @computed
    public get comment() {
        return this.model.comment;
    }

    @computed
    public get createdDate() {
        return this.model.createdDate ? `${moment(this.model.createdDate).format("DD/MM/YYYY")}` : "";
    }

    @computed
    public get createdByUserId() {
        return this.model.createdByUserId;
    }

    @computed
    public get createdByName() {
        return this.model.createdByName;
    }

    @computed
    public get isDeleted() {
        return this.model.isDeleted;
    }

    public afterUpdate: undefined;
    public beforeUpdate: undefined;

    public async isFieldValid(fieldName: keyof FieldType<RDDV2ItemResponseModel>): Promise<boolean> {
        return true;
    }
}
